// src/UploadTradeLicense.js
import React, { useState } from "react";
import "./UploadTradeLicense.modules.css";
import { useTranslation } from "react-i18next";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import { Redirect } from "react-router-dom";
import * as Constants from "../../../constants/Constants";
import * as Helpers from "../../../global/Helpers";
import * as utils from "../../../global/utils";
import * as AppUrls from "../../../constants/AppUrls";
import i18next from "i18next";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";

const UploadTradeLicense = () => {
  const { t } = useTranslation();
  const [redirect, setRedirect] = useState(null);
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isUploade, setisUplode] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingLogin);
  };
  const handleSubmit = async (e) => {
    ;
    e.preventDefault();

    if (!file) {
      setisUplode(false);
      setMessage("");
      setError(t("PleaseUpdateYourExpiredDocuments"));
      return;
    } else {
      setisUplode(false);
      setError("");
      //    setMessage('File uploaded successfully!');
    }

    // Simulate file upload
    // setTimeout(() => {
    //     setMessage(t("FileUplodedSuccessfully"));
    //     setFile(null);
    //     setError('');
    //     setisUplode(true);
    //     setRedirect(AppUrls.login);

    // }, 1000);
    var arrayofbyte = await Helpers.getAsByteArray(file);
    var bytesString = [].slice.call(arrayofbyte);

    var FileType = file.type;
    FileType = FileType.split("/");
    if (FileType !== null) FileType = FileType[1];

    const body = {
      fields: [
        { DocType: FileType, field_id: "160", field_value: bytesString },
      ],
      RequestId: localStorage.getItem("RID"),
    };

    var response = utils.CallInsertAttachments(
      Constants.InsertAttachments,
      body
    );
    await response
      .then((response) => {
        ;
        if (response.data.ErrorMsg === "success") {
          // setMessage(t("FileUplodedSuccessfully"));
          setMessage("");
          setFile(null);
          setError("");
          setisUplode(true);
          //setRedirect(AppUrls.login);
          SubmitPopUPconfirm();
          // setTimeout(() => {
          //   setRedirect(AppUrls.login);
          // }, 3000);
        } else if (response.data.ErrorMsg === "Invalid token") {
          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <SessionExpiredPOPup
                  setRedirect={setRedirect}
                  onClose={onClose}
                />
              );
            },
          });
        } else {
          Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
        }
      })
      .catch((error) => {
        console.log("CallInsertAttachments", error);
      });

    //setRedirect(AppUrls.login);
  };

  const SubmitPopUPconfirm = () => {
    var dir = "ltr";
    if (i18next.language == "ar") {
      dir = "rtl";
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className={
              "custom-popup custom-scrollable Onboarding-SubmitPopup " +
              localStorage.getItem(
                Constants.localStorageConstants.company_name
              ) +
              "-CSS"
            }
            style={{ direction: dir }}
          >
            <div className="custom-popup-body pt-2 pb-2">
              {<label>{t("Onboarding-SubmitPopupMSG")}</label>}
              <div className="mt-3 mb-2" style={{ textAlign: "center" }}>
                <button
                  className={"btn custom-btn-cancel "}
                  style={{
                    background:
                      localStorage.getItem(
                        Constants.localStorageConstants.company_name
                      ) === "ADCB"
                        ? "linear-gradient(to right, #dc2623, #ec0100)"
                        : "  background: linear-gradient(to right, #FAA634, #E37D00)",
                  }}
                  onClick={(e) => {
                    setRedirect(AppUrls.login);
                    onClose();
                  }}
                >
                  {t("ok")}
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  };
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }
  return (
    <>
      <NavbarOnboarding />
      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">
            {t("OpenYourAccountwithUs")}
          </h2>
          <img className="KYCImg" src={KYCimg} />
        </div>
        <div className="upload-container">
          <div className="upload-container-form">
            <h2>{t("UploadTradeLicense")}</h2>
            {message && <div className="alert success">{message}</div>}
            {error && <div className="alert error">{error}</div>}

            <div className="form-group-uploadON">
              <label htmlFor="file-upload">{t("SelectTradeLicenseFile")}</label>
              <input id="file-upload" type="file" onChange={handleFileChange} />
            </div>
            <div
              className="form-group-uploadON"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <button
                style={{ width: "45%" }}
                type="submit"
                onClick={(e) => handleSubmit(e)}
              >
                {t("upload")}
              </button>
              <button
                style={{ width: "45%" }}
                onClick={(e) => {
                  setError("");
                  setMessage("");
                  setisUplode(false);
                }}
              >
                {t("cancel")}
              </button>
            </div>
            <div>
              {/* <button
                className={"link"}
                style={{
                  width: "100%",
                  textDecoration: "underline",
                  marginTop: "1rem",
                  marginLeft: "auto",
                  marginRight: "auto",
                  background: "transparent",
                  border: "none",
                  color: "#0b1d81",
                  cursor: "pointer",
                }}
                onClick={handleBack}>
                {t("back")}
              </button> */}
              {/* <button className="backBtn" onClick={handleBack}>
                {t("back")}
              </button> */}
            </div>
            {/* {isUploade ? <h6>Thank you! Our representative will contact you soon to take the next steps. If you have any questions, feel free to contact us at 12345678.</h6> : null} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadTradeLicense;
